export default __webpack_public_path__ + "static/media/successGif.57f3fb82.gif";